import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
import placeholder from './-assets/placeholder-overview.png';
export const Route = createFileRoute('/_staff/networks/_layout/_placeholders/overview')({
  component: () => <ComingSoonCover placeholderImage={placeholder} />
});